var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditPrimary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi:edit-2",
    clipPath: "url(#clip0_2819_163179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3359 2.00004C11.511 1.82494 11.7189 1.68605 11.9477 1.59129C12.1765 1.49653 12.4216 1.44775 12.6693 1.44775C12.9169 1.44775 13.1621 1.49653 13.3909 1.59129C13.6196 1.68605 13.8275 1.82494 14.0026 2.00004C14.1777 2.17513 14.3166 2.383 14.4114 2.61178C14.5061 2.84055 14.5549 3.08575 14.5549 3.33337C14.5549 3.58099 14.5061 3.82619 14.4114 4.05497C14.3166 4.28374 14.1777 4.49161 14.0026 4.66671L5.0026 13.6667L1.33594 14.6667L2.33594 11L11.3359 2.00004Z",
    stroke: "#0082CD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2819_163179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPrimary);
export default __webpack_public_path__ + "static/media/edit-primary.3546b294ae4d34ef55a3d583d54dd7dd.svg";
export { ForwardRef as ReactComponent };